<template>
  <div class="container popular-categories px20 pb3">
    <div v-if="showDescription">
      <h2 class="w-100 start-md mt30 mb20">
        {{ title ? title : $t('The most popular artists') }}
      </h2>
      <h3 class="c-other regular mt0 mb30 popular-categories-description hidden-mobile">
        {{ description ? description : $t('Some of the most popular artists on our website') }}
      </h3>
    </div>
    <div class="categories-wrapper">
      <ul class="row p0 m0 flex start-md">
        <li
          v-for="artist in categoryArtists"
          :key="artist.id"
          class="w-100 flex flex-column align-center p0 mb16"
          :id="'cat-' + artist.id"
        >
          <a
            :href="getArtistUrl(artist)"
            class="no-underline py5 flex flex-1 flex-column"
          >
            <div class="image-wrapper w-100 relative">
              <img
                class="w-100 h-100 element-loading"
                :alt="artist.name"
                :src="artist.imageUrl"
                :srcset="getArtistSrcset(artist)"
                width="238"
                height="179"
              >
            </div>
            <div class="w-100">
              <p class="mt2 mb0 regular category-name-heading align-left">
                {{ artist.name }}
              </p>
            </div>
            <span class="w-100 event-count c-other pt3 pb2 fs12 lh15 align-left">
              {{ artist.eventCount + ' ' + $t('events') }}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'

export default {
  name: 'PopularArtists',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 5
    },
    categoryArtists: {
      type: Array,
      default: () => { }
    },
    showDescription: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getArtistUrl (artist) {
      return formatCategoryLink({ url_path: artist.url_path })
    },
    getArtistSrcset (artist) {
      if (!artist.imageUrlRetina) {
        return null
      }

      return `${artist.imageUrl} 1x, ${artist.imageUrlRetina} 2x`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/grid';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

.recommended-events,
.popular-categories {
  p {
    margin: 0;
  }

  ul {
    list-style: none;
  }

  @include mobile {
    padding-right: 0;

    ul {
      flex-wrap: nowrap;
      overflow-x: auto;
      scrollbar-width: none;
      gap: 10px;
      justify-content: flex-start;
    }

    li {
      flex: 0 0 auto;
      width: auto;
    }

    .image-wrapper {
      height: 120px;
      width: 160px;
    }

    .category-name-heading {
      font-size: 15px;
      line-height: 18px;
      margin-top: 2px;
    }

    .recommended-event-category-title {
      margin-top: 5px;
      margin-bottom: 5px;
      font-size: 22px;
      line-height: 27px;
    }
  }

  @include tablet {
    h2 {
      margin-top: 20px;
      margin-bottom: 5px;
    }

    .popular-categories-description,
    .category-name-heading {
      font-size: 18px;
      line-height: 20px;
    }

    .category-name-heading {
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .event-count {
      font-size: 16px;
      margin-bottom: 3px;
    }
  }

  @include desktop {
    h2 {
      margin-bottom: 5px;
      font-size: 40px;
      line-height: 48px;
    }

    .popular-categories-description,
    .category-name-heading {
      font-size: 24px;
      line-height: 29px;
    }

    .category-name-heading {
      margin-top: 10px;
      margin-bottom: 5px;
    }
  }

  li {
    a {
      border-radius: 10px;

      &:hover,
      &:focus {
        h6 {
          color: color(primary);
        }
      }
    }
  }

  .image-wrapper {
    img {
      border-radius: 10px;
      object-fit: cover;
        object-position: top;
    }
  }
}

.popular-categories {

  @include mediaQuery(sm, null) {
    li {
      max-width: calc((100% - 4 * 20px) / 5);
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }

    .image-wrapper {
      aspect-ratio: 4 / 3;
      overflow: hidden;
    }
  }

  @include desktop {
    padding: 0 85px 3px 85px;

    h2 {
      text-align: left;
      margin-top: 40px;
      font-size: 40px;
      line-height: 48px;
    }

    li {
      h6 {
        margin-top: 5px;
      }
    }

    .event-count {
      font-size: 18px;
      margin-bottom: 3px;
    }
  }
}

.recommended-events {
  li {
    padding-left: 7px;
    padding-right: 7px;
    margin-bottom: 13px;
  }

  .image-wrapper {
    overflow: hidden;
    padding-bottom: 114%;

    img {
      object-fit: cover;
      object-position: top;
    }
  }

  @include tablet {
    .recommended-events-description {
      font-size: 15px;
      line-height: 18px;
    }

    .recommended-event-category-title {
      font-size: 15px;
      line-height: 18px;
      margin-top: 9px;
      margin-bottom: 5px;
    }
  }

  @include desktop {
    h2 {
      margin-top: 19px;
    }

    .container {
      &.px20 {
        padding-left: 85px;
        padding-right: 85px;
      }
    }

    .categories-wrapper {
      &.px10 {
        padding-left: 75px;
        padding-right: 75px;
      }
    }

    li {
      width: 20%;
      max-width: 20%;
      flex-basis: 20%;
      padding-left: 9px;
      padding-right: 9px;
      margin-bottom: 13px;

      &:nth-child(6) {
        display: none;
      }

      a {
        padding: 10px;
      }

      h6 {
        margin-top: 15px;
      }
    }

    .recommended-events-description {
      font-size: 24px;
      line-height: 29px;
    }

    .recommended-event-category-title {
      margin-top: 9px;
      margin-bottom: 5px;
      font-size: 24px;
      line-height: 29px;
    }
  }
}

.no-padding {
  padding: 0;
}
</style>
